"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapReportPopularity = exports.syncReportPopularityForCurrentOrganization = exports.getPopularById = exports.getPopularByType = void 0;
const internalAxios_1 = require("./internalAxios");
const getPopularByType = async (reportType) => {
    const { data } = await internalAxios_1.internalAxios.get(`/api/popular/${reportType}`);
    return data;
};
exports.getPopularByType = getPopularByType;
const getPopularById = async (reportType, reportId) => {
    const response = await internalAxios_1.internalAxios.post(`/api/popular/${reportType}`, {
        body: {
            reportId,
        },
    });
    return response;
};
exports.getPopularById = getPopularById;
const syncReportPopularityForCurrentOrganization = async (reportType, reports, popularReport) => {
    const reportIds = reports.map((report) => report.id.toString());
    if (!popularReport || popularReport.length < 1) {
        popularReport = await (0, exports.getPopularById)(reportType, reportIds);
    }
    return (0, exports.mapReportPopularity)(reports, popularReport);
};
exports.syncReportPopularityForCurrentOrganization = syncReportPopularityForCurrentOrganization;
const mapReportPopularity = (reports, popular) => {
    const orgWideViewCount = popular
        .map((report) => report.viewCount)
        .reduce((prev, next) => prev + next);
    reports.forEach((report) => {
        report.popularity =
            ((popular.find((recent) => recent.reportId === report.id.toString())
                ?.viewCount ?? 0) /
                orgWideViewCount) *
                100.0;
    });
    return reports;
};
exports.mapReportPopularity = mapReportPopularity;
